<template>
  <div v-if="PaxsHotel && lang['hotel_mobile_new']">
    <Title
      :title-name="title.HotelTransport.titleName"
      :title-link="title.HotelTransport.titleLink"
      name-page="hotelTransport"
      :pax-voucher-id="$route.query.pax_voucher_id"
    />
    <div class="container" style="padding: 14pt 15px">
      <p>
        <span>{{ langDear }}</span
        >,
      </p>
    </div>
    <div class="block-item">
      <div class="container">
        <h3 style="padding: 10pt 0" class="title">{{ lang.hotel_mobile_new.SFS_LANG_ROW_30 }}</h3>
      </div>
    </div>
    <div class="container shuttle-bus-info">
      <h2 class="title sb_mobile sb_coupon" style="padding-left: 45pt; width: 100%">{{ PaxsHotel.name }}</h2>
      <div v-if="PaxsHotel.transport_available && PaxsHotel.transport_available == 1">
        <span class="font-weight-bold font-italic">{{ lang.hotel_mobile_new.SFS_LANG_ROW_31 }}:</span>
        {{ PaxsHotel.pickup_details }}
        <div class="operation-hours">
          <p class="font-weight-bold" style="margin: 14pt 0pt">{{ lang.hotel_mobile_new.SFS_LANG_ROW_32 }}:</p>
          <table v-if="operationHours.length" class="text-center" border="1" style="width: 100%">
            <tr>
              <td></td>
              <td style="color: rgb(136, 136, 136)">{{ lang.hotel_mobile_new.SFS_LANG_ROW_33 }}</td>
              <td style="color: rgb(136, 136, 136)">{{ lang.hotel_mobile_new.SFS_LANG_ROW_34 }}</td>
            </tr>
            <tr v-for="(time, index) in operationHours" :key="index">
              <td>{{ day[time.index] }}</td>
              <td>
                <p v-for="(hour, key) in time.data" :key="key">{{ hour.operating_opentime }} - {{ hour.operating_closetime }}</p>
              </td>
              <td>
                <p v-for="(hour, key) in time.data" :key="key">
                  {{ hour.frequency_service }} {{ lang.hotel_mobile_new.SFS_LANG_ROW_36 }}
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div v-else-if="PaxsHotel.transport_available && PaxsHotel.transport_available == 2">
        <span class="font-weight-bold font-italic">{{ lang.hotel_mobile_new.SFS_LANG_ROW_35 }}:</span>
        {{ PaxsHotel.desc_direction_hotel }}
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/Title/index'
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'

export default {
  name: 'HotelTransport',
  components: { Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      operationHours: [],
      day: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      langDear: ''
    }
  },
  computed: {
    ...mapGetters({
      PaxsHotel: 'SelectRoom/PaxsHotel'
    })
  },
  watch: {
    PaxsHotel: function () {
      if (_.isEmpty(this.PaxsHotel) || !this.PaxsHotel.transport_available) {
        // Doesn't has hotel data
        this.$router.push({ path: '/home', query: { secret: this.secret } })
        return
      }
      if (_.isEmpty(this.PaxsGroup) || _.isEmpty(this.pax)) {
        return
      }
      // Get data from operating time
      this.operationHours = _.filter(
        _.map(this.PaxsHotel.operating_time, function (obj, index) {
          if (obj.status) {
            obj.index = index
          }
          return obj
        }),
        function (o) {
          return o.status
        }
      )
      this.initData()
    },
    PaxsGroup: function () {
      if (_.isEmpty(this.PaxsHotel) || _.isEmpty(this.pax)) {
        return
      }
      this.initData()
    },
    pax: function () {
      let paxVoucherId = this.$route.query.pax_voucher_id
        ? this.$route.query.pax_voucher_id
        : !_.isEmpty(this.pax)
        ? this.pax.id
        : ''
      if (paxVoucherId) {
        let reservationId = this.$route.query.reservation_id
        let voucherId = this.$route.query.voucher_id
        this.$store.dispatch('SelectRoom/getVoucherHotel', {
          passenger_id: [paxVoucherId],
          reservation_id: reservationId,
          voucher_id: voucherId
        })
      }
      if (_.isEmpty(this.PaxsHotel) || _.isEmpty(this.PaxsGroup)) {
        return
      }
      this.initData()
    }
  },
  created() {
    let paxVoucherId = this.$route.query.pax_voucher_id
      ? this.$route.query.pax_voucher_id
      : !_.isEmpty(this.pax)
      ? this.pax.id
      : ''
    if (paxVoucherId) {
      let reservationId = this.$route.query.reservation_id
      let voucherId = this.$route.query.voucher_id
      this.$store.dispatch('SelectRoom/getVoucherHotel', {
        passenger_id: [paxVoucherId],
        reservation_id: reservationId,
        voucher_id: voucherId
      })
    }
  },
  methods: {
    replaceStr,
    initData() {
      if (!_.isEmpty(this.PaxsHotel) && !_.isEmpty(this.PaxsGroup) && !_.isEmpty(this.pax)) {
        this.langDear = replaceStr(
          this.lang['hotel_mobile_new'].SFS_LANG_ROW_29,
          ['<passenger_name>'],
          [this.PaxsHotel.title + ' ' + this.PaxsHotel.first_name + ' ' + this.PaxsHotel.last_name]
        )
        if (
          _.size(this.PaxsGroup) > 1 &&
          !_.isEmpty(this.PaxsHotel.group_passengers) &&
          _.size(this.PaxsHotel.group_passengers) > 0
        ) {
          this.langDear = replaceStr(this.lang['hotel_mobile_new'].SFS_LANG_ROW_29, ['<passenger_name>'], ['Guest'])
        }
        this.canDownload = true
      }
    }
  }
}
</script>
